// extracted by mini-css-extract-plugin
module.exports = {"FiveDaysForecastStyles":"FiveDaysForecast_FiveDaysForecastStyles__3v8U2","SearchResultsStyles":"FiveDaysForecast_SearchResultsStyles__2QOY9"};